module.exports = __webpack_public_path__ + "img/banner_2.2ff48c50.png";